var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-right-block"},[_c('div',{staticClass:"version2-left-block-p"},[_c('TopBlock'),_c('BottomBlock')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }